import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const [tournamentData, setTournamentData] = useState(null);

  useEffect(() => {
    const hostname = window.location.hostname;
        const socketUrl = (hostname === 'localhost' || hostname === '127.0.0.1')
          ? 'http://localhost:3000'
          : `https://${hostname}`;
        console.log('Connecting to WebSocket at:', socketUrl);
        const newSocket = io(socketUrl, { path: '/socket.io/' });
    
    newSocket.on('connect', () => {
      console.log('Connected to server');
      setConnected(true);
    });

    newSocket.on('disconnect', () => {
      console.log('Disconnected from server');
      setConnected(false);
    });

    newSocket.on('clock-update', (data) => {
      console.log('Clock update received:', data);
      setTournamentData(data);
    });

    newSocket.on('player-eliminated', (data) => {
      console.log('Player eliminated:', data);
    });

    setSocket(newSocket);

    return () => newSocket.close();
  }, []);

  const joinTournament = (tournamentId) => {
    if (socket) {
      socket.emit('join-tournament', tournamentId);
    }
  };

  const leaveTournament = (tournamentId) => {
    if (socket) {
      socket.emit('leave-tournament', tournamentId);
    }
  };

  return (
    <SocketContext.Provider value={{
      socket,
      connected,
      tournamentData,
      joinTournament,
      leaveTournament
    }}>
      {children}
    </SocketContext.Provider>
  );
};
